import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {Banner, BannerTypesEnum} from '../../../common/banners/banner';
import {BannerCloseAction} from '../../../common/banners/bannerCloseAction';
import {BannerContent} from '../../../common/banners/bannerContent';
import {BannerContentTitle} from '../../../common/banners/bannerContentTitle';
import {BannerIcon} from '../../../common/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../common/banners/bannersContext';

/*
 * Props.
 */

interface SuppressionListsRemovalBannerProps {
  onDismissClick: Handler;
  unsuppressedEmailAddress?: string;
}

/*
 * Component.
 */

export const SuppressionListsRemovalBanner: FC<SuppressionListsRemovalBannerProps> = ({
  unsuppressedEmailAddress,
  onDismissClick,
}) => {
  const theme = useUserTheme();
  if (!unsuppressedEmailAddress) {
    return null;
  }

  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      color={theme.palette.grey.shade40}
      priority={BannerPrioritiesEnum.TRANSIENT}
    >
      <BannerIcon iconName="checkmarkCircleSmall" />
      <BannerContent>
        <BannerContentTitle>
          <Trans id="banner-suppression-list-removal-title">Suppressions removed</Trans>
        </BannerContentTitle>
        <Trans id="banner-suppression-list-removal-description">
          Please re-send any failed messages to {unsuppressedEmailAddress}. If the problem persists, there may
          be an issue with the email address itself.
        </Trans>
      </BannerContent>
      <BannerCloseAction onClick={onDismissClick} />
    </Banner>
  );
};
